export const userPermissions = {
	BCC: "Branch of the Court Clerk",
	ADD_EVIDENCE: "Add Evidence",
	VIEW_EVIDENCE: "View Evidence",
	UPDATE_EVIDENCE: "Update Evidence",
	ADD_WITNESSS: "Add Witness",
	SUPER_ADMIN: "Super Admin",
	CASE_RAFFLE: "Case Raffle",
	UPDATE_CASE_BRANCHES: "Update Case Branches",
	UPDATE_CASE_STATUS: "Update Case Status",
	UPDATE_CASE_DEFENDANT: "Update Case Defendant",
	VIEW_CASE_DETAILS: "View Case Details",
	VIEW_CASE_ACTIVITIES: "View Case Activities",
	VIEW_CASE_HISTORY: "View Case History",
	ADD_HEARING: "Add Hearing",
	ADD_ACTIVITY: "Add Activity",
	EXPUNGE_ACTIVITY: "Expunge Activity",
	UPDATE_HEARING: "Update Hearing",
	ADD_COUNSEL: "Add Counsel",
	ADD_PARTY_COMPLAINT: "Add Party Complaint",
	VIEW_CASE_FILING: "View Case Filing",
	ADD_CASE_FILING: "Add Case Filing",
	UPDATE_CASE_FILING: "Update Case Filing",
	SERVINGS: "Servings",
	CALENDAR: "Calendar",
	ARTICLES: "Articles",
	REPORTS: "Reports",
	UPDATE_MOH: "Update Minutes of the Hearing",
	UPDATE_TSN: "Update TSN",
	ADD_SHERIFFS_REPORT: "Add Sheriffs Report",
};
